import { Dispatch } from 'redux';
import { fetcher } from '../../lib/request';
import { Discussions } from '../../models/Discussions/Discussion';
import { SOCKET } from '../../middlerware/socket';
import { isArray } from 'util';

export const GET_DISCUSSIONS_REQUEST = 'GET_DISCUSSIONS_REQUEST';
export const GET_DISCUSSIONS_RESPONSE = 'GET_DISCUSSIONS_RESPONSE';
export const GET_DISCUSSIONS_ERROR = 'GET_DISCUSSIONS_ERROR';

export const GET_DISCUSSION_REQUEST = 'GET_DISCUSSION_REQUEST';
export const GET_DISCUSSION_RESPONSE = 'GET_DISCUSSION_RESPONSE';
export const GET_DISCUSSION_ERROR = 'GET_DISCUSSION_ERROR';

export const CREATE_DISCUSSION_REQUEST = 'CREATE_DISCUSSION_REQUEST';
export const CREATE_DISCUSSION_RESPONSE = 'CREATE_DISCUSSION_RESPONSE';
export const CREATE_DISCUSSION_ERROR = 'CREATE_DISCUSSION_ERROR';

export const CLOSE_DISCUSSION_REQUEST = 'CLOSE_DISCUSSION_REQUEST';
export const CLOSE_DISCUSSION_RESPONSE = 'CLOSE_DISCUSSION_RESPONSE';
export const CLOSE_DISCUSSION_ERROR = 'CLOSE_DISCUSSION_ERROR';

export const SET_DISCUSSION = 'SET_DISCUSSION';
export const SET_IS_DISCUSSION_UPDATED = 'SET_IS_DISCUSSION_UPDATED';

export const DISCUSSION_UPDATED = 'DISCUSSION_UPDATED';
export const SET_NEW_DISCUSSION = 'SET_NEW_DISCUSSION';

export const REQUEST_DISCUSSION_START = 'REQUEST_DISCUSSION_START';
export const RESPONSE_DISCUSSION_START = 'RESPONSE_DISCUSSION_START';
export const ERROR_DISCUSSION_START = 'ERROR_DISCUSSION_START';

const DISCUSSIONS_HOST = process.env.REACT_APP_DISCUSSIONS_HOST;
const DISCUSSIONS_KEY = process.env.REACT_APP_DISCUSSIONS_KEY;

export const getDiscussionsAction = (clientId: string, discussion_type_id: number, page: number = 1) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_DISCUSSIONS_REQUEST,
    });

    try {
        const response = await fetcher(`${DISCUSSIONS_HOST}/api/v1/discussions?client_id=${clientId}&discussion_type_id=${discussion_type_id}&page=${page}`)
            .auth(`Basic ${DISCUSSIONS_KEY}`)
            .json();

        dispatch({
            type: GET_DISCUSSIONS_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_DISCUSSIONS_ERROR,
            error,
        });
    }
};

export const getDiscussionAction = (discussionId: number, userId: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_DISCUSSION_REQUEST,
    });

    try {
        const response = await fetcher(`${DISCUSSIONS_HOST}/api/v1/discussions/${discussionId}?client_id=${userId}`)
            .auth(`Basic ${DISCUSSIONS_KEY}`)
            .json();

        dispatch({
            type: GET_DISCUSSION_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: GET_DISCUSSION_ERROR,
            error,
        });
    }
};

function createFormData(data: any): FormData {
    let formData = new FormData();
    Object.keys(data).forEach(field => {
        const value = (data as any)[field];
        if (field === 'params') {
            Object.keys(value).forEach(paramField => {
                const paramValue = (value as any)[paramField];
                if (isArray(paramValue)) {
                    paramValue.forEach(v => {
                        formData.append('params[files][]', v);
                    });
                }
                if (paramValue !== undefined && paramValue !== null && !isArray(paramValue)) {
                    formData.append(`params[${paramField}]`, paramValue);
                }
            });
        } else if (value !== undefined && value !== null && !isArray(value)) {
            formData.append(field, value);
        }
    });
    return formData;
}

export const createDiscussionAction = (clientId: string, title: string, discussion_type_id: number, params?: any) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: CREATE_DISCUSSION_REQUEST,
    });

    try {
        const body = !params ? {
            client_id: clientId,
            discussion_type_id,
            title,
        } : {
            client_id: clientId,
            discussion_type_id,
            title,
            params: params
        };
        const response = await fetcher(`${DISCUSSIONS_HOST}/api/v1/discussions`)
            .auth(`Basic ${DISCUSSIONS_KEY}`)
            .post(createFormData(body))
            .json();

        dispatch({
            type: CREATE_DISCUSSION_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: CREATE_DISCUSSION_ERROR,
            error,
        });
    }
};

export const closeDiscussionAction = (id: number, clientId: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: CLOSE_DISCUSSION_REQUEST,
    });

    try {
        const body = {
            client_id: clientId
        };
        const response = await fetcher(`${DISCUSSIONS_HOST}/api/v1/discussions/${id}/close`)
            .auth(`Basic ${DISCUSSIONS_KEY}`)
            .post(body)
            .json();

        dispatch({
            type: CLOSE_DISCUSSION_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: CLOSE_DISCUSSION_ERROR,
            error,
        });
    }
};

export const setDiscussionAction = (discussion: Discussions) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_DISCUSSION,
        discussion,
    });
};

export const onDiscussionUpdated = (clientId: string, discussionId: number) => ({
    type: DISCUSSION_UPDATED,
    clientId,
    discussionId,
});

export const setIsDiscussionUpdated = (value: boolean) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_IS_DISCUSSION_UPDATED,
        value,
    });
};

export const setNewDiscussionAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_NEW_DISCUSSION
    });
};

export const discussionStartAction = (discussion_type_id: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_DISCUSSION_START,
        discussion_type_id
    });

    return dispatch({
        type: REQUEST_DISCUSSION_START,
        [SOCKET]: {
            type: 'EMIT',
            event: 'discussion_start',
            data: {discussion_type_id},
            successType: RESPONSE_DISCUSSION_START,
            errorType: ERROR_DISCUSSION_START,
        }
    });
};



// WEBPACK FOOTER //
// ./src/actions/Discussions/discussions.ts